import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "container", "icon"]

  toggle() {    
    if (this.containerTarget.classList.contains("hidden")) {
      this.containerTarget.classList.remove("hidden");
      if (!this.containerTarget.dataset.fetched) {
        this.loadPartial();
      }
    } else {
      this.containerTarget.classList.add("hidden");
    }
    this.iconTarget.classList.toggle('rotate-180')
  }

  async loadPartial(event) {
    const accountId = this.element.dataset.accountId
    const pipelineId = this.element.dataset.pipelineId
    const platformId = this.element.dataset.platformId
    const pipelineDestinationIds = this.element.dataset.pipelineDestinationIds
    const partialPath = this.element.dataset.partialPath
    const url = `/${partialPath}?account_id=${accountId}&pipeline_id=${pipelineId}&platform_id=${platformId}&pipeline_destination_ids=${pipelineDestinationIds}`;

    this.buttonTarget.classList.add("disabled")
    this.buttonTarget.style.pointerEvents = "none";
    this.buttonTarget.style.opacity = "0.5";

    Turbo.navigator.delegate.adapter.progressBar.setValue(0);
    Turbo.navigator.delegate.adapter.progressBar.show();

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Accept": "text/html"
        }
      });
  
      if (response.ok) {
        const html = await response.text();
        this.containerTarget.innerHTML = html;
      }
    } finally {
      Turbo.navigator.delegate.adapter.progressBar.hide()
      this.buttonTarget.classList.remove("disabled")
      this.buttonTarget.style.pointerEvents = "";
      this.buttonTarget.style.opacity = "";
      this.containerTarget.dataset.fetched = "true";
    }
  }
}
